import { render, staticRenderFns } from "./SetDrinkSoldTotalQuantity.vue?vue&type=template&id=0b9d8d58"
import script from "./SetDrinkSoldTotalQuantity.vue?vue&type=script&lang=js"
export * from "./SetDrinkSoldTotalQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports